module.exports = __webpack_public_path__ + "static/media/hanneke_knol_in_spanje.e2199ba4.png";